/* Тарифы приходят с сервера — их может быть сколько угодно, и часть не опубликована
   на сайте. Цвет назначается фронтендом по порядку, чтобы новый тариф не остался серым. */
const PALETTE = ['#6cb8ff', '#9a6aff', '#b642eb', '#d761af', '#4fd07e', '#f5d23a', '#24cee0', '#f58b3a'];
export const planColor = (plans, name) => {
  const i = plans.findIndex((p) => p.name === name);
  return PALETTE[(i < 0 ? 0 : i) % PALETTE.length];
};
export const STATUS = {
  TRIALING: { ru: 'триал', cls: 'b-trial' },
  ACTIVE: { ru: 'оплачено', cls: 'b-active' },
  UNPAID: { ru: 'не оплачено', cls: 'b-unpaid' },
  EXPIRED: { ru: 'истекла', cls: 'b-expired' },
  RETENTION: { ru: 'удаление', cls: 'b-retention' },
  SCHEDULED: { ru: 'отложена', cls: 'b-expired' },
  CANCELLED: { ru: 'отменена', cls: 'b-expired' },
};
export const STATUS_COLOR = {
  TRIALING: '#6cb8ff', ACTIVE: '#4fd07e', UNPAID: '#f58b3a', EXPIRED: '#3d4759', RETENTION: '#ff5268',
};
